import { useFiscalYearsList } from "helpers";
import { useModal } from "components/ModalGlobal";
import { parseDateBR } from "helpers/date";
import { maskDocument } from "helpers/document";
import React, { useEffect, useMemo, useState } from "react"
import { Button, Container } from "react-bootstrap";
import AdminRequestService from "services/admin-request";

function TableListCompanies({ list, blockChange, listBlocked }) {
  const [filter, setFilter] = useState({
    quantity: 20, name: ""
  });

  const listShow = useMemo(() => {
    return list.filter(item => {
      if (listBlocked.includes(item.id)) {
        return false;
      }
      if (!!filter.search) {
        return (
          item.name.toLowerCase().indexOf(filter.search.toLowerCase()) != -1
          ||
          item.document.indexOf(filter.search) != -1
          ||
          maskDocument(item.document).indexOf(filter.search) != -1
        );
      }
      return true;
    }).slice(0, filter.quantity);
  }, [list, filter, listBlocked]);

  return (
    <>
      <label className="mt-4">Lista de empresas</label>
      <div className="area-table">
        <input placeholder="Pesquisar" onInput={(e) => {
          let value = e.target.value;
          setFilter(old => ({ ...old, quantity: 20, search: value }))
        }} />
        <div className="area-table-pagination" onScroll={(e) => {
          const currentScrollY = e.target.scrollTop;
          const scrollHeight = e.target.scrollHeight - e.target.offsetHeight;
          if (currentScrollY > scrollHeight) {
            if (list.length > filter.quantity) {
              setFilter(old => ({ ...old, quantity: old.quantity + 10 }))
            }
          }
        }}>
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>CNPJ</th>
                <th style={{ width: "0px" }}></th>
              </tr>
            </thead>
            <tbody>
              {listShow.map((item, index) => {
                return <tr key={index}>
                  <td>{item.name}</td>
                  <td>{maskDocument(item.document)}</td>
                  <td>
                    <Button size="sm" onClick={() => blockChange(1, item.id)}>Bloquear</Button>
                  </td>
                </tr>
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

function TableBlockedCompanies({ list, blockChange }) {
  const [filter, setFilter] = useState({
    quantity: 20, name: ""
  });

  const listShow = useMemo(() => {
    return list.filter(item => {
      if (!!filter.search) {
        return (
          item.name.toLowerCase().indexOf(filter.search.toLowerCase()) != -1
          ||
          item.document.indexOf(filter.search) != -1
          ||
          maskDocument(item.document).indexOf(filter.search) != -1
        );
      }
      return true;
    }).slice(0, filter.quantity);
  }, [list, filter]);

  const all_years = useFiscalYearsList();

  return (
    <>
      <label>Lista de empresas bloqueadas</label>
      <div className="area-table">
        <input placeholder="Pesquisar" onInput={(e) => {
          let value = e.target.value;
          setFilter(old => ({ ...old, quantity: 20, search: value }))
        }} />
        <div className="area-table-pagination" onScroll={(e) => {
          const currentScrollY = e.target.scrollTop;
          const scrollHeight = e.target.scrollHeight - e.target.offsetHeight;
          if (currentScrollY > scrollHeight) {
            if (list.length > filter.quantity) {
              setFilter(old => ({ ...old, quantity: old.quantity + 10 }))
            }
          }
        }}>
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>CNPJ</th>
                <th>Data de bloqueio</th>
                <th>Anos bloqueados</th>
                <th style={{ width: "0px" }}></th>
              </tr>
            </thead>
            <tbody>
              {listShow.map((item, index) => {
                return <tr key={index}>
                  <td>{item.name}</td>
                  <td>{maskDocument(item.document)}</td>
                  <td>{parseDateBR(item.created_at)}</td>
                  <td id={`block-fiscal-year-list-${item.id}`}>{all_years.filter(a => item.years.indexOf(a.id) != -1).map(a => a.fiscal_year).join(", ")}</td>
                  <td>
                    <Button size="sm" onClick={() => blockChange(0, item.id)}>Desbloquear</Button>
                  </td>
                </tr>
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

function ModalToConfirmation({ companyId, isBlocked, years }) {
  const [data, setData] = useState([]);

  const [checkeds, setCheckeds] = useState(() => {
    let obj = {};
    years.forEach((a) => {
      obj[a.id] = true;
    })
    return obj;
  })

  useEffect(() => {
    AdminRequestService.getUsersBlock(companyId).then(data => {
      setData(data.data.return);
    })
  }, [companyId]);

  return (
    <div>
      {isBlocked ?
        <>
          <div>
            <label>Anos:</label>
            {years.map(a => {
              let id = `block-sistem-year-${a.id}`
              return <div key={a.id}>
                <input
                  className="block-sistem-year"
                  checked={checkeds[a.id]}
                  type="checkbox"
                  id={id}
                  name={id}
                  value={a.id}
                  onChange={(e) => {
                    let checked = document.getElementById(id).checked;
                    setCheckeds(old => {
                      old[a.id] = checked; return { ...old };
                    })
                  }}
                />
                <label htmlFor={id} style={{ paddingLeft: ".5rem" }}>{a.fiscal_year}</label>
              </div>;
            })}
          </div>
          <div>
            <h6>Usuários que serão bloqueados:</h6>
            {data.length > 0 ? (
              <table>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Email</th>
                    <th>Perfil</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((d, i) => {
                    return (
                      <tr key={i}>
                        <td>{d.full_name}</td>
                        <td>{d.email}</td>
                        <td>{d.profile_name}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : <center>Nenhum usuário relacionado</center>}
          </div>
        </>
        : 'Deseja realmente continuar?'}
    </div>
  )
}

export default function BlockSistem({ companiesList }) {
  const [list] = useState(companiesList);

  const [listBlocked, setListBlocked] = useState([]);
  const { showModal } = useModal();

  const all_years = useFiscalYearsList();
  const [years] = useState(() => {
    return all_years.filter(a => a.block != 1);
  })

  useEffect(() => {
    AdminRequestService.getBlockedCompanies().then(({ data }) => {
      setListBlocked(data);
    })
  }, []);

  async function blockChange(is_blocked, company_id) {
    let data = null;
    if (is_blocked == 1) {
      data = await AdminRequestService.getUsersBlock(company_id)
      data = data.data.return;
    }

    showModal({
      title: 'Confirmação',
      body: <ModalToConfirmation isBlocked={is_blocked} companyId={company_id} years={years}/>,
      buttons: [
        { label: 'Sim', value: true, variant: 'primary' },
        { label: 'Não', value: false, variant: 'danger' }
      ]
    }).then(result => {
      if (result) {
        let years_list = [];
        if(is_blocked){
          years_list = Array.from(document.querySelectorAll('.block-sistem-year:checked')).map(a => a.value);
        } else {
          years_list = JSON.parse("["+document.querySelector(`#block-fiscal-year-list-${company_id}`).innerText+"]").map(a=>{
            let y = years.filter(b=>{
              return b.fiscal_year == a
            });
            if(y.length > 0){
              return y[0].id
            }
            return null;
          }).filter(a=>!!a);
        }
        if (years_list.length > 0) {
          let formData = new FormData();
          formData.append("is_blocked", is_blocked);
          formData.append("company_id", company_id);

          years_list.forEach((y, k) => {
            formData.append(`years[${k}]`, y);
          })

          AdminRequestService.changeBlockSistem(formData).then(({ data }) => {
            if (is_blocked == 1) {
              setListBlocked(old => ([...old, data]))
            } else {
              setListBlocked(old => {
                return old.filter(item => item.id != data.id);
              })
            }
          })
        }
      }
    });
  }

  return (
    <Container>
      <h5>Bloqueio de canais ao sistema</h5>
      <hr />
      <TableBlockedCompanies list={listBlocked} blockChange={blockChange} />
      <TableListCompanies list={list} blockChange={blockChange} listBlocked={listBlocked.map(item => item.id)} />
    </Container>
  );
}